import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ROUTES } from '@common/interfaces';

/** Employee-only branches: blocks users whose primary role is ADMIN (redirects to sign-in). */
export const userGuard: CanActivateFn = () => {
  const router = inject(Router);
  try {
    const userDetails = JSON.parse(
      localStorage.getItem('userInfo') as string
    );
    if (userDetails?.roles?.[0] !== 'ADMIN') {
      return true;
    }
  } catch {
    // userInfo absent or invalid JSON — treat as unauthenticated
  }
  router.navigate([ROUTES.SIGN_IN]);
  return false;
};
